import { render, staticRenderFns } from "./part-number-change.vue?vue&type=template&id=c0a56f38&"
import script from "./js/part-number-change.js?vue&type=script&lang=js&"
export * from "./js/part-number-change.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports